
const Badge = ({text, light, dark}) => {
  return (
    <span className={`badge p-2 rounded-pill text-bg-${light ? "light" : "dark"}`}>{text}</span>
  )
}

export default Badge